// Native theme drawers/forms remain responsible for filtering and accessibility.
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-pmd-filter]');
  if (!trigger) return;
  const drawer = document.getElementById(trigger.getAttribute('aria-controls'));
  if (!drawer) return;
  for (const group of drawer.querySelectorAll('[data-pmd-filter-label]')) {
    const detail = group.querySelector('details');
    if (detail) detail.open = group.dataset.pmdFilterLabel === trigger.dataset.pmdFilter;
  }
});

// Colour story
function selectColour(tab, focus = false) {
  const story = tab.closest('.pmd-colour-story');
  if (!story) return;
  for (const button of story.querySelectorAll('[role="tab"]')) {
    const selected = button === tab;
    button.setAttribute('aria-selected', String(selected));
    button.tabIndex = selected ? 0 : -1;
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (panel) panel.hidden = !selected;
  }
  if (focus) tab.focus();
}
document.addEventListener('click', (event) => {
  const tab = event.target.closest('.pmd-colour-story [role="tab"]');
  if (tab) selectColour(tab);
});
document.addEventListener('keydown', (event) => {
  const tab = event.target.closest('.pmd-colour-story [role="tab"]');
  if (!tab || !['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
  const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
  let next = tabs.indexOf(tab) + (['ArrowUp', 'ArrowLeft'].includes(event.key) ? -1 : 1);
  if (event.key === 'Home') next = 0;
  if (event.key === 'End') next = tabs.length - 1;
  event.preventDefault();
  selectColour(tabs[(next + tabs.length) % tabs.length], true);
});

// Retain Prestige's recommendation and browsing-history loaders; only switch their panels.
function setupProductTabs() {
  if (document.body.dataset.pageType !== 'product') return;
  const related = document.querySelector('.shopify-section--related-products');
  const recent = document.querySelector('.shopify-section--recently-viewed-products');
  if (!related || !recent || related.dataset.pmdTabs) return;
  related.dataset.pmdTabs = 'true';
  const bg = document.documentElement.lang.startsWith('bg');
  const nav = document.createElement('div');
  nav.className = 'pmd-product-tabs container';
  nav.setAttribute('role', 'tablist');
  nav.setAttribute('aria-label', bg ? 'Още продукти' : 'More products');
  const panels = [related, recent].map(section => {
    const panel = document.createElement('div'); panel.id = `${section.id}-panel`;
    section.before(panel); panel.append(section); return panel;
  });
  const names = bg ? ['Препоръчваме ви', 'Последно разгледахте'] : ['You may also like', 'Recently viewed'];
  panels.forEach((panel, i) => {
    const button = document.createElement('button');
    button.type = 'button'; button.id = `pmd-product-tab-${i}`;
    button.textContent = names[i]; button.setAttribute('role', 'tab');
    button.setAttribute('aria-controls', panel.id);
    panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', button.id);
    panel.classList.add('pmd-product-panel');
    button.addEventListener('click', () => select(i));
    button.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : 1 - i;
      select(next); nav.children[next].focus();
    });
    nav.append(button);
  });
  function select(index) {
    panels.forEach((panel, i) => {
      panel.hidden = i !== index;
      nav.children[i].setAttribute('aria-selected', String(i === index));
      nav.children[i].tabIndex = i === index ? 0 : -1;
    });
  }
  panels[0].before(nav); select(0);
  const empty = document.createElement('p');
  empty.className = 'pmd-recent-empty container';
  empty.textContent = bg ? 'Разгледайте още продукти — ще ги намерите тук.' : 'Browse more products and find them here.';
  panels[1].append(empty);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupProductTabs);
else setupProductTabs();

// theme.js moves a single size value into the payment-terms row with an English label; localise it on BG.
function localiseOneSizeLabel() {
  if (document.body.dataset.pageType !== 'product' || !document.documentElement.lang.startsWith('bg')) return;
  const label = document.querySelector('.product-info [data-block-type="payment-terms"].force-flex > div:first-child');
  const text = label?.firstChild;
  if (text?.nodeType === Node.TEXT_NODE && text.textContent.trim() === 'Size:') text.textContent = 'Размер: ';
}
document.addEventListener('DOMContentLoaded', () => setTimeout(localiseOneSizeLabel, 0));

// Kiwi Sizing injects its size-chart link wherever it finds a hook; keep it beside the size label as in the PDF.
(() => {
  const section = document.querySelector('.shopify-section--main-product');
  if (document.body.dataset.pageType !== 'product' || !section) return;
  let saved = null; // variant changes re-render the picker and drop Kiwi's link; re-attach the same node
  const place = () => {
    const link = section.querySelector('.ks-chart-container') || saved;
    if (!link) return;
    saved = link;
    if (link.isConnected && link.closest('.variant-picker__option-info')) return;
    const info = [...section.querySelectorAll('.variant-picker__option-info')].find(el =>
      /size|размер/i.test(el.querySelector('legend')?.textContent || '') && el.closest('fieldset')?.style.display !== 'none');
    if (info) info.append(link);
  };
  new MutationObserver(place).observe(section, {childList: true, subtree: true});
  place();
})();

/* Reuse the app's published review text, ratings and associated product photos. */
(() => {
 const mount = () => {
  const section=document.querySelector('[id$="__pmd_reviews"]');
  if(!section || section.querySelector('.pmd-review-track')) return;
  const widget=section.querySelector('.jdgm-carousel');
  const reviews=widget?.querySelectorAll('.jdgm-carousel-item');
  if(!reviews?.length) return;
  const title=section.querySelector('.jdgm-carousel-title');if(title){const heading=document.createElement('h2');heading.className='pmd-review-heading';heading.textContent=document.documentElement.lang.startsWith('bg')?'Клиентите за нас':'Our customers say';title.before(heading);}
  const track=document.createElement('div');track.className='pmd-review-track';track.tabIndex=0;track.setAttribute('aria-label',document.documentElement.lang.startsWith('bg')?'Отзиви от клиенти':'Customer reviews');
  const seen=new Set();
  reviews.forEach(review=>{
   const id=review.getAttribute('data-review-id');if(seen.has(id))return;seen.add(id);
   const card=document.createElement('article');card.className='pmd-review-card';
   const photo=review.querySelector('img.jdgm-carousel-item__product-image');
   if(photo?.alt)card.dataset.pmdProduct=photo.alt.trim();
   if(photo){const img=document.createElement('img');img.className='pmd-review-photo';img.src=photo.getAttribute('data-src')||photo.src;img.alt=photo.alt;img.loading='lazy';card.append(img);}
   else {const empty=document.createElement('div');empty.className='pmd-review-photo';empty.setAttribute('aria-hidden','true');card.append(empty);}
   const copy=document.createElement('div');copy.className='pmd-review-copy';
   const name=document.createElement('h3');name.className='pmd-review-name';name.textContent=review.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent.trim();copy.append(name);
   const stars=review.querySelector('.jdgm-carousel-item__review-rating')?.cloneNode(true);if(stars){stars.className='pmd-review-stars';copy.append(stars);}
   const body=document.createElement('p');body.className='pmd-review-body';body.textContent=review.querySelector('.jdgm-carousel-item__review-body')?.textContent.trim();copy.append(body);{const more=document.createElement('button');more.type='button';more.className='pmd-review-more';more.hidden=true;more.textContent=document.documentElement.lang.startsWith('bg')?'Прочети повече':'Read more';more.setAttribute('aria-expanded','false');more.addEventListener('click',()=>{const expanded=more.getAttribute('aria-expanded')==='true';more.setAttribute('aria-expanded',String(!expanded));body.classList.toggle('pmd-review-body--expanded',!expanded);});copy.append(more);}card.append(copy);track.append(card);
  });
  if(!track.children.length)return;
  widget.hidden=true;widget.style.setProperty('display','none','important');widget.after(track);
  const actions=document.createElement('div');actions.className='pmd-review-actions';
  // One card per step; "next" at the end wraps back to the first review.
  const step=(direction)=>{const width=track.firstElementChild.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).columnGap)||0);const atEnd=track.scrollLeft+track.clientWidth>=track.scrollWidth-4;track.scrollTo({left:direction>0&&atEnd?0:track.scrollLeft+direction*width,behavior:'smooth'});};
  for(const [direction,label,symbol] of [[-1,'Previous reviews','←'],[1,'Next reviews','→']]){const button=document.createElement('button');button.type='button';button.textContent=symbol;button.setAttribute('aria-label',label);button.addEventListener('click',()=>{lastInteraction=Date.now();step(direction);});actions.append(button);}track.after(actions);
  // "Read more" only where the clamped text actually overflows.
  const syncMore=()=>track.querySelectorAll('.pmd-review-card').forEach(card=>{const body=card.querySelector('.pmd-review-body'),more=card.querySelector('.pmd-review-more');if(body&&more)more.hidden=!(body.classList.contains('pmd-review-body--expanded')||body.scrollHeight>body.clientHeight+1);});
  new ResizeObserver(syncMore).observe(track);document.fonts?.ready.then(syncMore);syncMore();
  // Photo, name and "Read more" open the reviewed product. The carousel markup only carries the product title (photo alt), so it is
  // resolved through the storefront's predictive search (exact title match only, once the reviews near the viewport).
  // No match keeps the in-place expand.
  const norm=s=>(s||'').trim().toLowerCase().replace(/\s+/g,' ');
  const lookups=new Map();
  const resolve=title=>{if(!lookups.has(title))lookups.set(title,fetch(`${window.Shopify?.routes?.root||'/'}search/suggest.json?q=${encodeURIComponent(title)}&resources[type]=product&resources[limit]=10&resources[options][fields]=title`).then(r=>r.ok?r.json():null).then(d=>{const p=d?.resources?.results?.products?.find(p=>norm(p.title)===norm(title));return p?.url?p.url.split('?')[0]:null;}).catch(()=>null));return lookups.get(title);};
  const linkCard=(card,url)=>{
   const img=card.querySelector('img.pmd-review-photo');if(img&&!img.closest('a')){const a=document.createElement('a');a.className='pmd-review-photo-link';a.href=url;a.tabIndex=-1;a.setAttribute('aria-hidden','true');img.replaceWith(a);a.append(img);}
   const name=card.querySelector('.pmd-review-name');if(name&&!name.querySelector('a')){const a=document.createElement('a');a.href=url;a.textContent=name.textContent;name.replaceChildren(a);}
   const more=card.querySelector('button.pmd-review-more');if(more){const a=document.createElement('a');a.className='pmd-review-more';a.href=url;a.hidden=more.hidden;a.textContent=more.textContent;more.replaceWith(a);}
  };
  const linkObserver=new IntersectionObserver(entries=>{if(!entries.some(e=>e.isIntersecting))return;linkObserver.disconnect();
   track.querySelectorAll('.pmd-review-card[data-pmd-product]').forEach(card=>resolve(card.dataset.pmdProduct).then(url=>{if(url){linkCard(card,url);syncMore();}}));
  },{rootMargin:'800px 0px'});linkObserver.observe(track);
  // Gentle autoplay (Adi H3): every 4.5s while visible; pauses on hover, focus, touch, recent interaction or an expanded review; off for reduced motion.
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');let hovering=false,focused=false,touching=false,visible=false,lastInteraction=0;
  section.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')hovering=true;});section.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse')hovering=false;});
  section.addEventListener('focusin',()=>{focused=true;});section.addEventListener('focusout',e=>{if(!section.contains(e.relatedTarget))focused=false;});
  track.addEventListener('touchstart',()=>{touching=true;lastInteraction=Date.now();},{passive:true});track.addEventListener('touchend',()=>{touching=false;lastInteraction=Date.now();},{passive:true});track.addEventListener('touchcancel',()=>{touching=false;},{passive:true});
  track.addEventListener('wheel',()=>{lastInteraction=Date.now();},{passive:true});
  new IntersectionObserver(([entry])=>{visible=entry.isIntersecting;},{threshold:.4}).observe(track);
  setInterval(()=>{if(reduced.matches||!visible||hovering||focused||touching||document.hidden||Date.now()-lastInteraction<8000||track.querySelector('.pmd-review-body--expanded')||track.scrollWidth<=track.clientWidth+4)return;step(1);},4500);
  observer.disconnect();
 };
 const observer=new MutationObserver(mount);observer.observe(document.documentElement,{childList:true,subtree:true});mount();
 window.addEventListener('pagehide',()=>observer.disconnect(),{once:true});
})();
